import React, {useState} from "react";
import {Modal} from "react-bootstrap";
import {defaultList} from "../generic/InitialStates";
import {ENTITY_ID_AUDIT_LOGS} from "../generic/Constants";
import {GenericTable} from "../generic/table/GenericTable";
import {HeaderColumnFormatter} from "../../column-formatters/HeaderColumnFormatter";
import {DMSDateColumnFormatter} from "../../column-formatters/DMSDateColumnFormatter";

export function AuditHistoryDialog(props) {
    const {show, handleClose, id} = props;
    const [reload, setReload] = useState(1);

    const columns = [
        {
            dataField: "name",
            text: "Name",
            formatter: HeaderColumnFormatter
        },
        {
            dataField: "description",
            text: "Description",
        },
        {
            dataField: "createdOn",
            text: "On",
            formatter: DMSDateColumnFormatter,
        },
        {
            dataField: "createdBy",
            text: "By",
        },
    ];

    return (
        <Modal
            size="lg"
            show={show}
            onHide={handleClose}
            aria-labelledby="example-modal-sizes-title-lg">
            <Modal.Header closeButton>
                <Modal.Title>Audit History</Modal.Title>
            </Modal.Header>
            <Modal.Body className="overlay">
                <GenericTable
                    reload={reload}
                    defaultData={defaultList}
                    columns={columns}
                    entityId={ENTITY_ID_AUDIT_LOGS}
                    fixedFilterData={id}
                    fixedFilterColumn={"entityId"}
                />
            </Modal.Body>
        </Modal>
    );
}
